module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-04-e5f8b9a7.svg";